// @ts-nocheck
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useToast } from '@/hooks/use-toast';

const productList = async (placeId) => {
  const sp = new URLSearchParams();
  sp.append('msdsId', placeId);
  sp.append('full', '1');
  sp.append('allowDisabled', '1');

  const { data } = await axiosInstance.get(
    `/api/abo/resamania2/products?${sp.toString()}`
  );
  
  return data;
};

export const useProductRefresh = ({placeId}) => {
  const queryClient = useQueryClient();
  const {toast} = useToast();

  return useMutation({
    mutationFn: async () => {
      const sp = new URLSearchParams();
      sp.append('msdsId', placeId);
      const { data } = await axiosInstance.put(
        `/api/abo/resamania2/products?${sp.toString()}`
      );
      
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['products', placeId],
      });
      queryClient.refetchQueries(['products', placeId]);
      toast({
        variant: "default",
        title: "Votre configuration a été mise à jour",
      });
    },
    onError: () => {
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};

export const useProductList = ({placeId}) => {
  const {toast} = useToast();
  return useQuery({
    queryKey: ['products', placeId],
    queryFn: async () => {
      const result = await productList(placeId);
      toast({
        variant: "default",
        title: "Produits mis à jour",
      });
      return result;
    },
    enabled: !!placeId
  })
};
